export default __webpack_public_path__ + "static/media/pentest.483c576b.png";